export function snapToFrame(time: number, fps: number) {
  return Math.round(time * fps) / fps;
}

// Garde ta version de generateFullTimeline ici
export function generateFullTimeline(rawSegments: any[], duration: number) {
  let cuts = rawSegments
    .map((seg: any) => ({
      ...seg,
      start: Math.max(0, Math.min(duration, seg.start)),
      end: Math.max(0, Math.min(duration, seg.end)),
    }))
    .filter((seg: any) => seg.end > seg.start)
    .sort((a: any, b: any) => a.start - b.start);

  const result = [];
  let last = 0;

  for (let i = 0; i < cuts.length; i++) {
    if (cuts[i].start > last) result.push({ start: last, end: cuts[i].start, speed: 1 });
    result.push({ ...cuts[i] });
    last = cuts[i].end;
  }
  if (last < duration) result.push({ start: last, end: duration, speed: 1 });

  return result.reduce((acc, cur) => {
    if (acc.length > 0 && acc[acc.length - 1].speed === cur.speed && cur.speed === 1) {
      acc[acc.length - 1].end = cur.end;
    } else acc.push({ ...cur });
    return acc;
  }, []);
}

export async function pollJobResult(jobId: any, onDone: any, { delay = 3000, maxTries = 40 } = {}) {
  let tries = 0;
  return new Promise((resolve, reject) => {
    const check = async () => {
      tries++;
      try {
        const response: any = await fetch(`https://ns3258217.ip-51-75-216.eu/get-video-result/${jobId}`);
        const data = await response.json();
        console.log("Job status:", data.returnvalue);
        if (data.status === "done") {
          onDone?.(data.url);
          resolve(data.url);
        } else if (data.status === "failed") {
          reject(new Error(data.error || "Erreur lors du traitement vidéo"));
        } else if (tries < maxTries) {
          setTimeout(check, delay);
        } else {
          reject(new Error("Timeout: le job n'a pas terminé à temps."));
        }
      } catch (e) {
        reject(e);
      }
    };
    check();
  });
}
